import React, { useMemo } from 'react'
import { SubscriptionInfo } from '~/api/generated/graphql'
import { useNewActivity } from '~/contexts/NewActivityContext'

export const NewActivityButton = ({
  newActivity,
  loading,
  showNewActivity,
}: {
  loading: boolean
  newActivity: SubscriptionInfo[]
  showNewActivity: () => Promise<void>
}) => {
  const { knownCommentIds, knownPostIds } = useNewActivity()

  const doShowNewActivity = async () => {
    await showNewActivity?.()
  }

  const showMoreActivityButton = useMemo(() => {
    // Show the button only if there is activity not already visible to the user.
    // knownCommentIds: comments already shown inline in expanded posts.
    // knownPostIds: posts already in the feed from a manual loadMore.
    const filteredActivity = [...(newActivity ?? [])].filter(
      x => x && !knownCommentIds?.includes(x.objId) && !knownPostIds?.includes(x.objId)
    )
    return filteredActivity.length > 0 && !loading
  }, [newActivity, loading, knownCommentIds, knownPostIds])

  return (
    <>
      {showMoreActivityButton && (
        <button className={'new-activity-message'} onClick={doShowNewActivity} data-testid="show-new-activity">
          Show new activity
        </button>
      )}
    </>
  )
}
